import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { CommentViewerComponent } from './comment-viewer.component';

export const ngxCommentViewerModule = angular.module('ngxCommentViewerModule', [])
	.directive('ngxCommentViewer', downgradeComponent({component: CommentViewerComponent}))
	.name;
